/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

let sliderWrapper = document.querySelector('.moody-image-slider-wrapper');
if ( sliderWrapper !== null ) {

    let glideDiv = document.createElement('div');
    glideDiv.classList.add('glide');

    let glideTrack = document.createElement('div');
    glideTrack.classList.add('glide__track');
    glideTrack.setAttribute( 'data-glide-el', 'track' );

    let glideControls = document.createElement('div');
    glideControls.classList.add('glide__arrows');
    glideControls.setAttribute( 'data-glide-el', 'controls' );

    let leftButton = document.createElement('button');
    leftButton.classList.add('glide__arrow', 'glide__arrow--left');
    leftButton.setAttribute( 'data-glide-dir', '<' );
    leftButton.textContent = '<';

    let rightButton = document.createElement('button');
    rightButton.classList.add('glide__arrow', 'glide__arrow--right');
    rightButton.setAttribute( 'data-glide-dir', '>' );
    rightButton.textContent = '>';

    glideControls.appendChild( leftButton );
    glideControls.appendChild( rightButton );


    let glideSlides = document.createElement('div');
    glideSlides.classList.add('glide__slides');

    while ( sliderWrapper.querySelector('img') !== null ) {
        let child = sliderWrapper.removeChild( sliderWrapper.querySelector('img') );
        child.classList.add('glide__slide');
        glideSlides.appendChild( child );
    }

    glideTrack.appendChild( glideSlides );
    glideDiv.appendChild( glideTrack );
    glideDiv.appendChild( glideControls );
    sliderWrapper.appendChild( glideDiv );

    new Glide( '.glide', {
        autoplay: 5000
    } ).mount()

}
